import { render } from "./InsightCard.vue?vue&type=template&id=56fc7e1c&scoped=true"
import script from "./InsightCard.vue?vue&type=script&lang=js"
export * from "./InsightCard.vue?vue&type=script&lang=js"

import "./InsightCard.vue?vue&type=style&index=0&id=56fc7e1c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56fc7e1c"]])

export default __exports__